import React, { useContext, useEffect, useState } from "react";
import { Heading, Input, SectionHeading } from "../../../components";
import { ResumeContext } from "../../../contexts/resumeContext";
import {deleteIcon, Plus} from '../../../components/Icons/Icons';
import styles from "./CoursesForm.module.css";

const newCourseBlock = {
  name: "",
  institution: "",
  startDate: "",
  endDate: "",
};

function CoursesForm() {
  const {updateResumeInfo, resumeInfo} = useContext(ResumeContext);
  
  const [courseDetails, setCourseDetails] = useState(
    Object.values(resumeInfo?.misc?.courses || {0: {...newCourseBlock}}) || [{}]
  );

  useEffect(() => {
    const miscSection = {...resumeInfo.misc}
    miscSection['courses'] = courseDetails
    
    updateResumeInfo.current("misc", miscSection, resumeInfo);
  }, [courseDetails]);

  const handleChange = (e, ix) => {
    let courseDetailsArr = [...courseDetails];
    let courseDetailsObj = courseDetailsArr[ix];
    courseDetailsObj[e.target.name] = e.target.value;
    courseDetailsArr[ix] = courseDetailsObj;
    setCourseDetails(courseDetailsArr);
  };
  const addNewBlock = () => {
    let courseDetailsTemp = [...courseDetails];
    courseDetailsTemp = [...courseDetailsTemp, {...newCourseBlock}];
    setCourseDetails(courseDetailsTemp);
  };

  const deleteBlock = (ix) => {
    let courseDetailsTemp = [...courseDetails];
    courseDetailsTemp.splice(ix, 1);
    setCourseDetails(courseDetailsTemp);
  };

  return (
    <div>
      <SectionHeading editable content="Courses" section="CR"/>
      {courseDetails.map((course, ix) => (
        <div className="block" key={`course_${ix}`}>
          <button className="delete-btn" onClick={() => deleteBlock(ix)}><img src={deleteIcon}/></button>
          <div className="row">
            <div className="col">
              <Input
                label="Course"
                name="name"
                value={course.name}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
            <div className="col">
              <Input
                label="Institution"
                name="institution"
                value={course.institution}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Start Date (YYYY/MM)"
                name="startDate"
                placeholder="YYYY/MM"
                type="month"
                pattern="[0-9]{4}/[0-9]{2}"
                value={course.startDate}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
            <div className="col">
              <Input
                label="End Date (YYYY/MM)"
                name="endDate"
                placeholder="YYYY/MM"
                type="month"
                pattern="[0-9]{4}/[0-9]{2}"
                value={course.endDate}
                onChange={(e) => handleChange(e, ix)}
              />
            </div>
          </div>
        </div>
      ))}
      <button className="link" onClick={addNewBlock}>
        Add More Course <Plus />
      </button>
    </div>
  );
}

export default CoursesForm;
